/**
 * 경원 차량번호 짧게 — "20-5107-0"·"123가4567"·"12-3456" → 4자리 "5107"·"4567"·"3456" (10-22 사용자 지정).
 * OKIS SELL.S_CARNUM 실데이터 6,786건이 모두 4자리 숫자 덩어리 하나를 가짐(빈칸 1건). 4자리가 없으면 원문 그대로.
 * 묶음(차량별 집계)·건수는 원문 번호로 하고 화면 글자만 줄인다 — 다른 차량이 같은 4자리를 쓰는 경우가 있어(과거 12개)
 * 원문은 title 로 남긴다.
 */
export function shortCarNo(carNo: string): string {
  const s = carNo.trim();
  return s.match(/(?<!\d)\d{4}(?!\d)/)?.[0] ?? s;
}
